"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Base = /** @class */ (function () {
    function Base() {
    }
    // tslint:disable-next-line:naming-convention
    Base.prototype.isEmpty = function () {
        return this._is_empty();
    };
    // tslint:disable-next-line:naming-convention
    Base.prototype.toString = function () {
        if (this.isEmpty()) {
            throw new Error("Output is empty.");
        }
        return this._to_string();
    };
    // tslint:disable-next-line:naming-convention
    Base.prototype.toRegExp = function (flags) {
        return new RegExp(this.toString(), flags);
    };
    return Base;
}());
exports.Base = Base;
